import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { EnvoiFichierComparerOffre } from '../../engine/ApiCommunicator'
import {
    CalculNbDocumentPretPourComparerOffre,
    CalculPoidTotalDocPourComparerOffre,
} from '../../engine/Rules'
import store from '../../engine/store'
import { InfoBulle } from '../ImportAll'
import './Bloc.css'

const mega20 = 20971520
const mega5 = 5242880
class BlocImportDocument extends Component {
    constructor(props) {
        super(props)
        this.importFile = this.importFile.bind(this)
        this.removeFile = this.removeFile.bind(this)
    }

    /**
		Ajout de documents
		gére l'ajout au store + push api
	**/
    importFile(newFiles) {
        var files = this.props.files.filter((file) => true)
        var onlyRealNewFiles = []
        newFiles.forEach((newFile) => {
            if (
                files.filter(
                    (existingFile) => existingFile.name === newFile.name
                ).length === 0
            ) {
                if (
                    newFile.type !== 'image/jpeg' &&
                    newFile.type !== 'application/pdf' &&
                    newFile.type !== 'image/png'
                ) {
                    //console.log("Mauvais format de fichier : "+newFile.type)
                } else {
                    if (newFile.size > mega5) {
                        //console.log("Fichier trop gros : "+newFile.size)
                    } else {
                        const newTotalSize =
                            newFile.size +
                            CalculPoidTotalDocPourComparerOffre(files)
                        if (newTotalSize > mega20) {
                            //console.log("Total document supérieur 20 Mo")
                        } else {
                            newFile.etat_envoi = 'LOAD'
                            newFile.uuid = ''
                            files.push(newFile)
                            onlyRealNewFiles.push(newFile)
                        }
                    }
                }
            }
        })
        store.dispatch({ type: 'SET', value: { key: 'files', value: files } })

        onlyRealNewFiles.forEach((file) => {
            EnvoiFichierComparerOffre(file, this.props.token_csrf)
        })
    }
    /**
		remove un fichier du store
	**/
    removeFile(fileName) {
        var files = this.props.files.filter((file) => file.name !== fileName)
        store.dispatch({ type: 'SET', value: { key: 'files', value: files } })
        CalculNbDocumentPretPourComparerOffre(files)
    }

    render() {
        // définition du style du bloc
        let className = 'Bloc fade-in bloc-full'
        const style = {
            display: 'table',
        }

        // définition de l'état du bloc
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        // génére les lignes d'import de documents
        var filesDiv = []
        for (let i = 0; i < this.props.files.length; i++) {
            var currentFile = this.props.files[i]
            var currentFileName =
                currentFile.name.length > 30
                    ? currentFile.name.substring(0, 30) + '...'
                    : currentFile.name
            var statusEnvoi = ''
            if (currentFile.etat_envoi === 'LOAD') {
                statusEnvoi = (
                    <div className="TextDocuments size14">
                        (<b>Chargement..</b>){' '}
                    </div>
                )
            } else if (currentFile.etat_envoi === 'SEND') {
                statusEnvoi = (
                    <div className="TextDocuments size14">
                        (<b>Envoyé!</b>){' '}
                    </div>
                )
            } else if (currentFile.etat_envoi === 'ERR') {
                statusEnvoi = (
                    <div className="TextDocuments size14">
                        (<b>Echec envoi</b>){' '}
                    </div>
                )
            }
            filesDiv.push(
                <div key={'file' + i} className="Documents">
                    <div className="TextDocuments size14">
                        {currentFileName}{' '}
                    </div>
                    {statusEnvoi}
                    <div
                        className="DeleteDocuments size14"
                        onClick={(e) =>
                            this.removeFile(this.props.files[i].name)
                        }
                    >
                        {' '}
                        <b>Supprimer</b>{' '}
                    </div>
                </div>
            )
        }
        style.height = 310 + filesDiv.length * 45 + 'px'

        // l'affichage général du composant)
        const styleBoxFile = {
            overflow: 'auto',
            width: '80%',
            marginLeft: '10%',
            marginTop: '10px',
            backgroundColor: '#EEF3F4',
            borderRadius: '20px',
            borderWidth: '1px',
            borderStyle: 'dotted',
            borderColor: 'black',
            padding: '10px',
        }

        let premadeContent
        premadeContent = (
            <div className="BlocImportDocument">
                <div className="simpleDoubleWord1 bold-font">
                    Champs documents
                </div>
                <Dropzone
                    onDrop={(acceptedFiles) => this.importFile(acceptedFiles)}
                >
                    {({ getRootProps, getInputProps }) => (
                        <section>
                            <div {...getRootProps()} style={styleBoxFile}>
                                <input {...getInputProps()} />
                                <p>
                                    {' '}
                                    Scan, image, PDF ou photo de l'offre reçue
                                    par la banque afin de l'analyser{' '}
                                </p>
                                <img
                                    src="png/document.png"
                                    alt="icone importer document"
                                />
                                <p>
                                    Limité a 20 Mo pour l'ensemble des documents{' '}
                                </p>
                            </div>
                        </section>
                    )}
                </Dropzone>
                <div className="NbDocuments">
                    <b>{this.props.files.length}</b> documents chargés
                </div>
                {filesDiv}
            </div>
        )

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        files: state.answer['files'] ? state.answer['files'] : [],
        token_csrf: state.answer['tech_token_csrf'],
    }
}

export default connect(mapStateToProps)(BlocImportDocument)
